export enum NotificationType {
    INFORMATION,
    WARNING,
    SUCCESS,
    ERROR,
    CUSTOM
}
